import Rush from '@/components/features/casino/rush';
import getI18nProps from '@/utils/i18/getI18nProps';
import CatchError from '@/components/system/CacthError';

// export const runtime = 'experimental-edge';

const CasinoOriginalsPage = ({ game, onRemove }) => {
  return (
    <>
      <Rush />
    </>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(CasinoOriginalsPage);
